import * as http from './http';

// 加入vip
export const addVip = (params) => http.post(`/addVip`, params, { loading: false, interceptRes: false });
// 使用code码
export const useCode = (params) => http.post(`/redeemCode/useCode`, params, { loading: false, interceptRes: false });
// 确认下单金额
export const reqConfimOrder = (params) => http.post(`/order/confirm`, params, { loading: false, interceptRes: true });
// 下单
export const reqGenOrder = (params) => http.post(`/order/create`, params, { loading: false, interceptRes: false });
// 获取vip套餐
export const reqGetVipList = (params) => http.post(`/vipLevel/list`, params, { loading: false, interceptRes: true });
// 购买vip套餐获取优惠券
export const reqVipCouponList = (params) => http.post(`/coupon/userEnableCouponByOrderAmount`, params, { loading: false, interceptRes: false });
// 通过支付id查询支付结果
export const reqGetPayResult = (params) => http.post(`/order/payResultConfirm`, params, { loading: false, interceptRes: true });
// 通过订单id查询支付结果
export const reqPayResultConfirmByOrderId = (params) => http.post(`/order/payResultConfirmByOrderId`, params, { loading: false, interceptRes: true })




